import React from 'react';
import { OFFER } from '../data/offer';
const bonuses = [{
  number: '01',
  title: 'The First Two Weeks Quick-Start',
  price: 9,
  length: '12–16 pages',
  image: 'https://cdn.magicpatterns.com/uploads/ttc8HCUiHYJiS3JYfQ8sV6/12m-bono-1.webp',
  alt: 'The cover of The First Two Weeks Quick-Start standing on a table.',
  body: 'Just said yes? Here’s exactly what to do in the next fourteen days — and, more importantly, the five things everyone rushes that you shouldn’t touch yet.'
}, {
  number: '02',
  title: 'The Message Swipe File',
  price: 14,
  length: '24–30 pages of scripts',
  image: 'https://cdn.magicpatterns.com/uploads/h2uoLfV2bgXK4RBNoCr19D/12m-bono-2.webp',
  alt: 'The cover of The Message Swipe File standing on a marble table.',
  body: 'Copy-paste messages for the conversations nobody teaches you: chasing a quote without sounding pushy, chasing an RSVP without sounding annoyed, saying no to a plus-one, and handling the guest-list conversation with family.'
}, {
  number: '03',
  title: 'The Budget & Payments Tracker',
  price: 12,
  length: 'Spreadsheet + guide',
  image: 'https://cdn.magicpatterns.com/uploads/wx98v3dJ49PFTWxkXc5MNR/12m-bono-3.webp',
  alt: 'The cover of The Budget & Payments Tracker standing on a table.',
  body: 'The spreadsheet with every forgotten line already loaded, plus deposit and final-payment due dates so nothing lands as a surprise.'
}, {
  number: '04',
  title: 'The 12-Month Deadline Calendar',
  price: 11,
  length: 'One printable page',
  image: 'https://cdn.magicpatterns.com/uploads/fYYLwqvPgvb3QWBC6gZLwG/12m-bono-4.webp',
  alt: 'The cover of The 12-Month Deadline Calendar standing on a table.',
  body: 'One printable page. Every deadline of the year on it. Goes on the fridge, ends the “are we behind?” conversation.'
}, {
  number: '05',
  title: 'The RSVP Tracker',
  price: 9,
  length: 'Printable sheets',
  image: 'https://cdn.magicpatterns.com/uploads/4ZdTKY7mfq3JQooajhH9fu/12m-bono-5.webp',
  alt: 'The cover of The RSVP Tracker standing on a set table.',
  body: 'Printable, and built to survive the two weeks when replies come in three different channels at once.'
}];
export function Bonuses() {
  return <section aria-labelledby="bonuses-heading" className="w-full bg-white" data-id="element-30" data-mp="3qj7jzy9vx86y">
      <div className="max-w-6xl mx-auto px-5 sm:px-8 py-14 sm:py-20" data-id="element-31" data-mp="2tsf1yv3e562j">
        <p className="text-[13px] font-semibold uppercase tracking-kicker text-sage-deep text-center" data-id="element-32" data-mp="2tu9ogdub968q">
          5 bonuses included free
        </p>
        <h2 id="bonuses-heading" className="mt-4 font-serif font-normal text-ink text-[28px] sm:text-[38px] text-center" data-id="element-33" data-mp="32slcc83slpxh">
          Total value: ${OFFER.bonusValue}{' '}
          <span className="text-sage-deep" data-id="element-34" data-mp="2a4zab4a7qtcq">
            → free with your 12-Month Wedding Plan
          </span>
        </h2>

        <ul className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-35" data-mp="2f27sv5z9wzei">
          {bonuses.map(bonus => <li key={bonus.number} className="flex flex-col rounded border border-sage/20 bg-sand overflow-hidden" data-id="element-36" data-mp="27j892z7wh5um">
              <img src={bonus.image} alt={bonus.alt} loading="lazy" width={1024} height={1024} className="w-full aspect-[4/3] object-cover border-b border-sage/20" data-id="element-37" data-mp="1xl2b2sp7sjv1" />
              <div className="flex flex-col flex-grow p-6" data-id="element-38" data-mp="1jup2co4i114n">
                <span className="font-serif font-normal text-sage-deep text-[15px]" data-id="element-39" data-mp="1jt46mv6g7c57">
                  Bonus {bonus.number}
                </span>
                <h3 className="mt-2 font-serif font-medium text-ink text-[21px] leading-snug" data-id="element-40" data-mp="19wrfa3ydladm">
                  {bonus.title}
                </h3>
                <p className="mt-1.5 text-[13px] font-medium uppercase tracking-kicker text-sage-deep" data-id="element-41" data-mp="15u4f9frjwj5c">
                  {bonus.length}
                </p>
                <p className="mt-3 text-[17px] leading-[1.6] text-ink-soft" data-id="element-42" data-mp="30xapnyh9z7np">
                  {bonus.body}
                </p>
                <p className="mt-auto pt-6 flex items-baseline gap-2" data-id="element-43" data-mp="34y4d6qqt2kg2">
                  <span className="text-clay-dark line-through text-[15px]" data-id="element-44" data-mp="2r8ixbp8aylc9">
                    ${bonus.price}
                  </span>
                  <span className="font-serif italic text-sage-deep text-[19px]" data-id="element-45" data-mp="2w5j6wa4d2684">
                    Free
                  </span>
                </p>
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}